// src/pages/menu/AfricanWaitersDashboard.jsx
import React from 'react';
import LocationWaitersDashboard from '../LocationWaitersDashboard';

const AfricanWaitersDashboard = () => {
  return <LocationWaitersDashboard locationKey="african" />;
};

export default AfricanWaitersDashboard;